var config = {
  src: 'background/strona_009.jpg',
  scale: 0.8,
  cropp: {
    pos: {
      x: -110,
      y: -203,
      unit: 'px',
    },
    width: 1680,
    height: 1420,
  },
};
export default config;
